// React import
import React from 'react';
import { connect } from "react-redux";
// Components import
import WalletBaseStatItem from "../WalletBaseStatItem";
// Styles imports
import './WalletBaseStat.css';
import '../../util.css'

class WalletBaseStat extends React.Component {

    constructor(props) {
        super(props);
    }

    render () {

        const { walletStats } = this.props.checkWallet;
        const { ai_level, subscription } = this.props.userData;

        return (
            <div className={"token-analyzer__stats-block noselect"}>
                {walletStats.map(walletStat =>
                    <WalletBaseStatItem
                        key={walletStat.type}
                        type={walletStat.type}
                        indicator={walletStat.indicator}
                        stat={walletStat.stat}
                        firstDescription={walletStat.firstDescription}
                        secondDescription={walletStat.secondDescription}
                        aiLevel={ai_level}
                        subscription={subscription}
                    />
                )}
            </div>
        );
    }

}

const mapStateToProps = ({ checkWallet, userData }) => {
    return { checkWallet, userData };
};

export default connect(mapStateToProps)(WalletBaseStat);
